import React from "react";
import "./PlusMinusSelector.css";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

import AddIcon from "../../../assets/icons/Add.svg";
import MinusIcon from "../../../assets/icons/Minus.svg";

const PlusMinusSelector = ({
  value = 0,
  onChange,
  min = 0,
  max = 999,
  step = 1,
  width = "60px"
}) => {
  const handleDecrement = () => {
    const newValue = value - step;
    if (newValue >= min) {
      onChange?.(newValue);
    }
  };
  const handleIncrement = () => {
    const newValue = value + step;
    if (newValue <= max) {
      onChange?.(newValue);
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      onChange?.(0);
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= min && numValue <= max) {
      onChange?.(numValue);
    }
  };

  return (
    <div className="plus-minus-selector">
      <button
        type="button"
        className="selector-button"
        onClick={handleDecrement}
        disabled={value <= min}
      >
        <img src={MinusIcon} alt="plus"></img>
      </button>
      <input
        type="text"
        style={{
          width: width,
        }}
        className="selector-input"
        value={value}
        onChange={handleInputChange}
        readOnly={false}
      />
      <button
        type="button"
        className="selector-button"
        onClick={handleIncrement}
        disabled={value >= max}
      >
        <img src={AddIcon} alt="plus"></img>
      </button>
    </div>
  );
};

export default PlusMinusSelector;
